<script lang="ts">
  export let title: string;
</script>

<h2 class="my-1 px-2.5 py-2 text-xs">{title}</h2>
